import { render, staticRenderFns } from "./tabOthersLicense.vue?vue&type=template&id=4dd9b9b6&"
import script from "./tabOthersLicense.vue?vue&type=script&lang=js&"
export * from "./tabOthersLicense.vue?vue&type=script&lang=js&"
import style0 from "./tabOthersLicense.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports